import { useState } from "react";
import Chart from "react-apexcharts";
import { Dialog, Button, Typography, Grid, Box, Divider } from "@mui/material";
import NormalTable from "../../Component/NormalTable";
import { color } from "../../StyleData/Config";
import { masterAPI } from "../Masters/dataConfig";
import { axiosPrivate } from "../../axios/axios";

const AssetStatusChart = ({ xAxis, yAxis, type, dateFrom, dateTo }) => {
  const [subDialogOpen, setSubDialogOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [listData, setListData] = useState([]);

  const handleChartClick = (e, chartContext, config) => {
    const dataPointIndex = config?.dataPointIndex;
    if (dataPointIndex !== undefined && dataPointIndex >= 0) {
      const status = xAxis[dataPointIndex];
      setSelectedStatus(status);
      axiosPrivate
        .post(`${masterAPI["KPIReport"].getAssetStatusList}`, {
          status: status,
          createdDateFrom: dateFrom,
          createdDateTo: dateTo,
        })
        .then((res) => {
          setListData(res.data.result || []);
          setSubDialogOpen(true);
        })
        .catch((e) => {
          console.log(e);
          setListData([]);
          setSubDialogOpen(true);
        });
    }
  };

  const handleSubDialogClose = () => {
    setSubDialogOpen(false);
    setSelectedStatus("");
    setListData([]);
  };

  const columns = [
    { Header: "Asset Code", accessor: "code" },
    { Header: "Asset Name", accessor: "assetName" },
    { Header: "Category", accessor: "categoryName" },
    { Header: "Asset Type", accessor: "assetTypeName" },
    { Header: "Location", accessor: "locationName" },
    { Header: "Status", accessor: "statusName" },
  ];

  return (
    <>
      <Box sx={{ "& .apexcharts-bar-area": { cursor: "pointer" } }}>
      <Chart
        height={type ? (yAxis.length ? `${32 * yAxis.length + 200}px` : "100%") : 200}
        width={"100%"}
        options={{
          title: {
            text: "Asset Status",
            style: {
              fontFamily: "Nunito Sans, sans-serif",
              color: "#2362B4",
            },
          },
          chart: {
            type: "bar",
            toolbar: {
              export: {
                csv: { filename: "AssetStatus" },
                svg: { filename: "AssetStatus" },
                png: { filename: "AssetStatus" },
              },
            },
            events: {
              dataPointSelection: handleChartClick,
            },
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          yaxis: {
            title: { text: "Count" },
            labels: { show: type },
          },
          xaxis: {
            title: {
              text: "Status",
              style: { fontSize: "11px" },
            },
            categories: xAxis,
          },
        }}
        type="bar"
        series={[{ name: "Count", data: yAxis }]}
      />
      </Box>

      <Dialog
        open={subDialogOpen}
        onClose={handleSubDialogClose}
        maxWidth={"xl"}
        fullWidth
      >
        <Grid container>
          <Grid item xs={12}>
            <Box>
              <Typography
                sx={{
                  color: color.masterPageTitleColor,
                  fontSize: color.masterPageTitleFontSize,
                  fontWeight: color.masterPageTitleFontWeight,
                  mb: color.masterPageTitlemd,
                  px: 2,
                  py: 1,
                }}
              >
                Asset Status :{" "}
                <span style={{ color: color.masterDialogTitleColor }}>
                  {selectedStatus}
                </span>
              </Typography>
              <Box sx={{ px: 2, py: 1 }}>
                <NormalTable data={listData} columns={columns} filt={true} />
              </Box>
            </Box>
          </Grid>
          <Divider />
          <Grid container item justifyContent={"flex-end"}>
            <Button onClick={handleSubDialogClose}>Close</Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AssetStatusChart;
